export default "__VITE_ASSET__CPbZfp$v__"